<template>
<div class="tw-w-full tw-flex">
  <v-container style="max-width: 75rem" class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-8">
    <div style="width: 100%; align-items: center; justify-content: center; display: flex; margin-top: 2vh">
      <Logo/>
    </div>
    <div style="width: 100%; align-items: center; justify-content: center; display: flex; margin-top: 5vh">
      <v-card  class="card" elevation="0">
        <p class="account-header">Verify your email</p>
          <span>
            Please check your email, we’ve sent an email to <b>{{$route.query.email}}</b> for verification. Don’t worry, you’ll only do this once.
          </span>
      </v-card>
    </div>
  </v-container>
</div>
</template>

<script>
import Logo from "@/reuseable/Logo";
export default {
  name: "ConfirmEmail",
  components:{
    Logo

  },

}
</script>

<style scoped lang="scss">
.card{
  display: flex;
  width: 450px;
  border: 1px solid #EAEAEA;
  border-radius: 32px;
  flex-direction: column;
  padding: 3% 3%;
  height: 87vh;

}
span{
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #000000;
  margin-top: 20px;
  text-align: center;
}
.account-header{
  color: #292929;
  font-weight: 700;
  font-size: 32px;
  text-align: center;

  @media screen and (max-width: 768px){
    display: flex;
    width: 100%;
    justify-content: center;

  }

}

.err {
  display: block;
  color: red;
  font-size: 13px;
  margin-bottom: 5px;
}
</style>
